<div class="sign-out-container">
  <div class="sign-out-card">
    <h1>{{ 'allDone' | translate }}</h1>
    <h2>{{ 'signedOutMessage' | translate }}</h2>
    <div class="sign-out-card-footer">
      <span>{{ 'moreToDoSignBackIn' | translate }}</span>
      <p-button
        class="dap-sign-in"
        severity="secondary"
        [label]="'signIn' | translate"
        (onClick)="signIn()"
      />
    </div>
  </div>
</div>
